import React from 'react';
import { Badge } from '@oneaudi/unified-web-components';
import { AvailableBadgeWrapper } from './styles/CarinfoWrapper.styles';
import { getAvailabilityDetails } from '../../utils/getAvailabilityDetails';
import { footnoteRegEx, PlainTextWithFootnotes } from '../../../components';
export const AvailableBadge = ({ vehicleBasic, isPLP }) => {
    var _a;
    const businessModel = (vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.businessModel)
        ? (_a = vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.businessModel) === null || _a === void 0 ? void 0 : _a.code
        : 'dealer_stock';
    const carType = (vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.type.toUpperCase()) === 'U' ? 'uc' : 'nc';
    const { color, availabilityLabel } = getAvailabilityDetails(carType, businessModel, vehicleBasic.availableFrom, vehicleBasic.availableFromCode, vehicleBasic.reservation, vehicleBasic.dealer.city);
    const labelWithFootNote = (React.createElement("span", { "aria-label": availabilityLabel === null || availabilityLabel === void 0 ? void 0 : availabilityLabel.replace(footnoteRegEx, '') },
        React.createElement(PlainTextWithFootnotes, { text: availabilityLabel, useSpan: true })));
    return (React.createElement(AvailableBadgeWrapper, { isPLP: isPLP },
        React.createElement(Badge, { label: labelWithFootNote, labelPosition: "trailing", margin: [0, 0, 0, 0], semanticShape: color })));
};
